import { render, staticRenderFns } from "./PatentIndex.vue?vue&type=template&id=45c7f0ac&scoped=true&"
import script from "./PatentIndex.vue?vue&type=script&lang=ts&"
export * from "./PatentIndex.vue?vue&type=script&lang=ts&"
import style0 from "./PatentIndex.vue?vue&type=style&index=0&id=45c7f0ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c7f0ac",
  null
  
)

export default component.exports